import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { GameModel } from "../../../Models/GameModel";
export interface IScrollThumbControllerOptions {
    onScroll: (percent: number) => {}
}

export class ScrollThumbController extends AnimationBaseController {
    $model: GameModel
    private _clickY = 0;
    private _isPressed = false;
    public constructor(@Inject private _options: IScrollThumbControllerOptions) {
        super("ScrollThumbController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            onPointerDown: (e) => {
                this._clickY = e.screenPosition.y;
                this._isPressed = true;
                this._calc(e);
            },
            onPointerMove: (e) => {
                if (this._isPressed) {
                    this._calc(e);
                }
            },
            onPointerUp: () => {
                this._pointerUpHandler();
            },
            onPointerUpOutside: () => {
                this._pointerUpHandler();
            }
        };
    }

    protected onInitialize(): void {

    }

    public reset() {
        this.y = -160;
    }

    private _pointerUpHandler() {
        this._isPressed = false;
    }


    private _calc(e) {
        let y = e.localPosition.y - this._clickY;
        const min = -160;
        const max = 160;
        if (y >= max) {
            y = max;
        } else if (y <= min) {
            y = min;
        }
        const percent = (y - min) / (max-min);
        if (this._options.onScroll) {
            this._options.onScroll(percent);
        }
        this.y = y;
    }


}